<template>
  <el-dialog ref='dialog' title="流程流向">
    <div style="max-height: 300px;overflow-y: auto;">
      <el-checkbox
        v-model="checkAll"
        :isIndeterminate="isIndeterminate"
        @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <div v-for="(item, index) in currentData.currentContent" :key="item" class="m-l-20">
        <el-checkbox 
          v-model="item.selected"
          :label="item"
          @change="handleGruopChange(index, $event)">
        {{item.name}}
        </el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox 
          v-model="childItem.selected" 
          v-for="childItem in item.list" 
          :key="childItem" 
          :label="childItem" 
          class="m-l-20"
          @change="handleChildChange(index)"
          style="padding: 5px">
        {{childItem.realname}}
        </el-checkbox>
        <div style="margin: 15px 0;"></div>
      </div>
    </div>
    <div class="footer">
      <el-button @click="closeDialog()">取消</el-button>
      <el-button type="primary" @click="submitData()" :disabled="selectedId.length === 0">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    currentData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      selectedId: [],
      checkAll: false,
      isIndeterminate: false
    }
  },
  methods: {
    handleCheckAllChange(event) {
      let checked = event.target.checked
      _(this.currentData.currentContent).forEach((res) => {
        if (checked) {
          res.selected = true
        } else {
          res.selected = false
        }
        res.list = this.handleChildSelected(res.list, checked)
      })
      this.selectedId = this.getSelectedData()
    },
    handleGruopChange(index, event) { // 处理组项选择改变
      let arr = this.currentData.currentContent
      if (arr && arr[index].list && arr[index].list.length > 0) {
        let checked = event.target.checked
        arr[index].list = this.handleChildSelected(arr[index].list, checked)
        this.currentData.currentContent = arr
      }
      this.selectedId = this.getSelectedData()
    },
    handleChildChange(index) {
      // 获取该组长度 已选择的长度
      let temp = this.currentData.currentContent[index]
      let allLength = temp.list.length
      let selectedLength = (_.filter(temp.list, { selected: true })).length
      this.selectedId = this.getSelectedData()
    },
    handleChildSelected(firstArr, checked) {
      _(firstArr).forEach((res) => {
        if (checked) {
          res.selected = true
        } else {
          res.selected = false
        }
      })
      return firstArr
    },
    getSelectedData() {
      let data = this.currentData.currentContent
      let arr = []
      _(data).forEach((res) => {
        if (res.list && res.list.length > 0) {
          _(res.list).forEach((childRes) => {
            if (childRes.selected) {
              arr.push(childRes.id)
            }
          })
        }
      })
      return arr
    },
    clearData(arr) {
      this.selectedId = []
      this.checkAll = false
      this.isIndeterminate = false
      if (arr && arr.length > 0) {
        _(arr).forEach((res, index) => {
          res.selected = false
          if (res.list && res.list.length > 0) {
            _(res.list).forEach((childRes, childIndex) => {
              childRes.selected = false
            })
          }
        })
      }
      return arr
    },
    openDialog(postData) {
      this.postData = postData
      this.currentData.currentContent = this.clearData(this.currentData.currentContent)
      // 清空数据
      this.clearData()
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    submitData() {
      let arr = this.getSelectedData()
      setTimeout(() => {
        this.$emit('handleDialogResult', arr, this.postData)
      }, 200)
      this.closeDialog()
    }
  }
}
</script>



// WEBPACK FOOTER //
// flowProcessDialog.vue?562379e6